import { memo } from "react";

type Props = {
	primaryColor: string;
};

export const LikeReservationComponentCalendar = memo(({ primaryColor }: Props) => {
	return (
		<div className="w-full space-y-2">
			<div className="rounded-lg bg-white">
				<div className="p-1 ">
					<img className="mx-auto" src="/assets/like-reservation-component/calendar/inline-calendar.png" alt="Calendar" />
				</div>

				<div className="border-t px-2 pb-3 pt-3">
					<div>
						<div
							className="ml-auto w-[max-content] rounded-lg px-3 py-2"
							style={{ background: primaryColor }}
						>
							<p className="text-xs font-semibold text-white">日付を決めずに進める</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
